<template>
    <div class="card-body pt-2" v-if="item">

        <form-item v-if="item.proj_open_flg == '0'" 
                   lab="求人状況" icn="far fa-comment icon-size" class="text-success">
                    <div class="d-flex">
                        <span>{{converVal('proj_open_flg', item.proj_open_flg)}}</span>
                        <span v-if="item.id">&nbsp;[pj.{{item.id}}]</span>
                    </div>
        </form-item>
        <form-item v-else 
                    lab="求人状況" icn="far fa-comment icon-size" class="text-danger">{{converVal('proj_open_flg', item.proj_open_flg)}}</form-item>

        <form-item lab="募集終了予定日" :class="{'text-danger':isWarnFinish(item.proj_finish_date)}">{{converVal('proj_finish_date', item.proj_finish_date)}}</form-item>

        <form-item lab="案件名" icn="fas fa-laptop-code icon-size">{{item.proj_nm}}</form-item>
        <form-item v-if="item.proj_language" lab="開発言語" icn="fas fa-code-branch icon-size">{{item.proj_language}}</form-item>
        <form-item v-if="item.proj_position" lab="ポジション" icn="fas fa-sitemap icon-size">{{converVal('proj_position',item.proj_position)}}</form-item>
        <form-item lab="開始時期" icn="fas fa-calendar-alt icon-size">{{converVal('proj_start_date',item.proj_start_date)}}</form-item>
        <form-item v-if="item.proj_interview"
                   lab="面談回数" icn="fas fa-user-tie icon-size">{{converVal('proj_intv', item.proj_interview)}}</form-item>

        <form-item v-if="item.proj_price_set == '1'" 
                   lab="月額単価">スキル見合い</form-item>
        <form-item v-else-if="item.proj_price_start == '0'" 
                   lab="月額単価" icn="fas fa-yen-sign icon-size">~ {{converVal('proj_price_end', item.proj_price_end)}}</form-item>
        <form-item v-else-if="item.proj_price_start == item.proj_price_end" 
                   lab="月額単価" icn="fas fa-yen-sign icon-size">{{converVal('proj_price_end', item.proj_price_end)}}</form-item>
        <form-item v-else 
                   lab="月額単価" icn="fas fa-yen-sign icon-size">{{converVal('proj_price_start', item.proj_price_start)}} ~ {{converVal('proj_price_end', item.proj_price_end)}} </form-item>

        <div v-if="item.proj_price_pub == '0'" class="text-success">
            <form-item v-if="item.proj_price_pub_start == '0'"
                   lab="公開単価" icn="fas fa-comments-dollar icon-size">~ {{item.proj_price_pub_end}}&nbsp;万円</form-item>
            <form-item v-else-if="item.proj_price_pub_start == item.proj_price_pub_end"
                   lab="公開単価" icn="fas fa-comments-dollar icon-size">{{item.proj_price_pub_end}}&nbsp;万円</form-item>
            <form-item v-else 
                   lab="公開単価" icn="fas fa-comments-dollar icon-size">{{item.proj_price_pub_start}}&nbsp;万円 ~ {{item.proj_price_pub_end}}&nbsp;万円</form-item>
        </div>

        <form-item v-if="item.proj_is_adjust == '0'" 
                   lab="精算条件" icn="fas fa-calculator icon-size"
                   >あり&nbsp;({{item.proj_time_start}} ~ {{item.proj_time_end}}&nbsp;時間)</form-item>
        <form-item v-else-if="item.proj_is_adjust == '1'" lab="精算条件" icn="fas fa-calculator icon-size">固定</form-item>
        <form-item v-else-if="item.proj_is_adjust == '2'" lab="精算条件" icn="fas fa-calculator icon-size">あり(精算幅確認中)</form-item>
        <form-item v-else-if="item.proj_is_adjust == '3'" lab="精算条件" icn="fas fa-calculator icon-size">不明</form-item>

        <form-item v-if="item.proj_remote_ok" 
                   lab="リモートワーク" icn="fas fa-house-user icon-size">{{converVal('proj_remote_ok', item.proj_remote_ok)}}</form-item>

        <form-item v-if="item.proj_place" lab="最寄り駅" icn="fas fa-map-marker icon-size">{{item.proj_place}}</form-item>

        <form-item v-if="item.proj_members" 
                   lab="募集人数" icn="fas fa-user icon-size"
                   >{{converVal('proj_members', item.proj_members)}}</form-item>

        <form-item v-if="item.proj_start_time" 
                   lab="始業時間" icn="fas fa-clock icon-size"
                   >{{converVal('proj_start_time', item.proj_start_time)}}</form-item>

        <form-item v-if="item.proj_foreign_ok" 
                   lab="外国籍" icn="fas fa-globe icon-size">{{converVal('proj_foreign_ok', item.proj_foreign_ok)}}</form-item>

        <form-item lab="案件概要" icn="fas fa-quote-left icon-size">{{item.proj_detail}}</form-item>
        <form-item lab="必須スキル" icn="fas fa-code icon-size">{{item.proj_skill_need}}</form-item>
        <form-item v-if="item.proj_skill_option" 
                   lab="歓迎スキル" icn="fas fa-book-open icon-size">{{item.proj_skill_option}}</form-item>
        <form-item v-if="item.proj_note" 
                   lab="備考" icn="fas fa-pen-alt icon-size">{{item.proj_note}}</form-item>

        <hr>
        <div v-if="item.sys_note || item.mail_url" class="text-center text-danger">
            <p>=== 非公開内容 ===</p>
        </div>

        <form-item v-if="item.sys_note" 
                   lab="管理者備考(非公開)" icn="fas fa-user-edit icon-size">{{item.sys_note}}</form-item>

        <form-item v-if="item.mail_url" lab="メールURL">
            <a :href="item.mail_url" target="_blank">{{item.mail_url}}</a>
        </form-item>
    </div>
</template>

<script>
    import {isWarningProjFinishDate} from 'pages/commons/form/comFunc'
    import FormItem from 'pages/commons/form/Confirm'
    import {converVal} from 'pages/commons/form/selectList'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            FormItem,
        },
        props: {
            item: Object
        },
        methods: {
            converVal (name, val) {
                return converVal(name,val)
            },
            isWarnFinish (val) {
                return isWarningProjFinishDate(val)
            }
        }
    }
</script>

<style>
</style>
